import React, {useEffect, useMemo, useState} from "react";
import {ListItemIcon, Menu, MenuItem} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {makeStyles} from "@material-ui/styles";
import {ControlPointDuplicate, LibraryAdd as InsertIcon} from "@material-ui/icons";

const useStyles = makeStyles(() => ({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    },
}));

function isJson(item) {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
        value = JSON.parse(value);
    } catch (e) {
        return false;
    }

    return typeof value === "object" && value !== null;
}

export const ContextMenu = (props) => {
    const classes = useStyles();
    const {
        contextMenu, onClose, item, editItem, onDropComponent,
        duplicateItem, removeItem, path, parentPath, index, parentLength
    } = props;
    const [isActivePaste, setIsActivePaste] = useState(false);
    const isOpen = useMemo(() => {
        return contextMenu.mouseY !== null && contextMenu.mouseX !== null
    }, [contextMenu.mouseY, contextMenu.mouseX])

    useEffect(() => {
        async function checkIsActivePaste() {
            if (!isOpen) {
                setIsActivePaste(false)
                return
            }
            const clipboardValue = await navigator.clipboard.readText();

            if (!isJson(clipboardValue)) {
                setIsActivePaste(false)
                return
            }

            const clipboardObject = JSON.parse(clipboardValue)

            return setIsActivePaste(!(!clipboardObject.type && clipboardObject.type !== 'sysbu'))
        }
        checkIsActivePaste();
    }, [isOpen])


    function onCopy() {
        navigator.clipboard.writeText(JSON.stringify({type: 'sysbu', item}))
    }

    async function onPaste() {
        if (isActivePaste && item.children) {
            const clipboardValue = await navigator.clipboard.readText();
            const clipboardObject = JSON.parse(clipboardValue)
            onDropComponent(clipboardObject.item, item.children.length + 1, path ? `${path}.children` : 'children')
        }
    }

    return (
        <Menu
            classes={{list: classes.contextPaper}}
            open={contextMenu.mouseY !== null}
            anchorReference={"anchorPosition"}
            anchorPosition={isOpen ? {top: contextMenu.mouseY, left: contextMenu.mouseX} : undefined}
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    editItem(item, path);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <EditIcon fontSize="small"/>
                </ListItemIcon>
                Edit&nbsp;<span style={{textTransform: "capitalize"}}>{item.type}</span>
            </MenuItem>
            {duplicateItem && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        duplicateItem(parentPath ? `${parentPath}.children` : 'children', item, index);
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <ControlPointDuplicate fontSize="small"/>
                    </ListItemIcon>
                    Duplicate
                </MenuItem>
            )}

            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    onCopy()
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <FileCopyIcon fontSize="small"/>
                </ListItemIcon>
                Copy
            </MenuItem>
            {item.children && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    disabled={!isActivePaste}
                    onClick={(e) => {
                        e.stopPropagation();
                        onPaste();
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <InsertIcon fontSize="small"/>
                    </ListItemIcon>
                    Paste
                </MenuItem>
            )}
            {removeItem && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        removeItem(path, item.type, parentLength, parentPath);
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <HighlightOffIcon fontSize="small"/>
                    </ListItemIcon>
                    Remove
                </MenuItem>
            )}

        </Menu>
    )
};